<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="nommaedeptoast"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="NomMaeDepDialog" title="Confirmar Acción"
                 appendTo="body"></p-confirmDialog>
<div class="p-grid" style="width: 99%">
	<div class="p-col-12">
		<app-invmaebarra [botonNuevo]="maedepartamentoService.btnNuevo" [botonGuardar]="maedepartamentoService.btnGuardar" [botonBorrar]="maedepartamentoService.btnBorrar"
						 [botonRegresar]="maedepartamentoService.btnRegresar" [barraBotonesCRUD]="false"
						 [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true" [barraBotones5]="true"
						 (signal)="manejarSenales($event)"></app-invmaebarra>
	</div>

</div>

<div style="overflow: hidden" class="p-col-12">
	<p-tabView>
		<p-tabPanel header="Departamento">
			<app-aggridsaci [width]=""
							[height]="largo"
							[enableSorting]="false"
							[enableFilter]="true"
							[rowData]="maedepartamentoService.nommaedepartamento"
							[frameworkComponents]="frameworkComponents"
							[animateRows]="true"
							[rowSelection]="rowSelection"
							[columnDefs]="columnDefMaeDepartamento"
							[defaultColDef]="defaultColDefMaeDepartamento"
							[rowStyle]="rowStyle"
							[singleClickEdit]="false"
							[botones]="false"
							(selected)=selectMaeDepartamento($event)
							(cambios)="cambio($event)"

			></app-aggridsaci>
		</p-tabPanel>
	</p-tabView>
</div>